import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { RegExArrayValidator } from '@library/core/directives';
import { ErrorMessageService } from '@library/core/services';

import { UserService } from '../user';
import { PasswordRequirement, PasswordService } from './password.service';

function passwordMatchValidator(g: FormGroup) {
   return g.get('oldPassword').value !== g.get('newPassword').value
      ? null : { mismatch: true };
}

@Component({
   selector: 'lib-password-reset',
   templateUrl: './password.component.html',
   styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

   message: string;
   loading = false;

   passwordForm: FormGroup = new FormGroup({
      oldPassword: new FormControl( false ),
      newPassword: new FormControl( false ),
   });

   validation: PasswordRequirement[];
   
   constructor(
      public error: ErrorMessageService,
      private passwordService: PasswordService,
      public router: Router,
      public userService: UserService,
   ) { }

   ngOnInit() {
      this.passwordService.getRequirements().subscribe( res => {
         this.validation = res;
         this.passwordForm = this.setPasswordForm();
      });
   }

   get oldPassword() { return this.passwordForm.get('oldPassword'); }
   get newPassword() { return this.passwordForm.get('newPassword'); }

   setPasswordForm(): FormGroup {
      return new FormGroup({
         oldPassword: new FormControl( '', [ Validators.required]),
         newPassword: new FormControl( '', [ Validators.required, RegExArrayValidator( this.validation ) ]),
      }, passwordMatchValidator );
   }

   resetPassword() {
      if ( this.passwordForm.invalid ) {
         this.message = 'Minimum password standards are not met';
         return false;
      } else {
         this.loading = true;
         const oldPassword = this.passwordForm.get('oldPassword').value;
         const newPassword = this.passwordForm.get('newPassword').value;
         
         this.userService.getCognitoUser().then(cognitoUser => {
            this.userService.changePassword(cognitoUser, oldPassword, newPassword).then(
               response => {
                  if(response) {
                     this.router.navigate([ 'user' ]);
                  }
                  this.loading = false;
               }, 
               _ => {
                  this.router.navigate([ 'redirect', 'user/password' ], { skipLocationChange: true });
                  this.loading = false;
               }
            )
         });
      }
   }

   checkValidations(req: string) {
      const findKey = (obj, val) => {
         if (typeof obj === "object") {
           for (const key in obj) {
             if (obj[key] === val) {
               return key;
             } else {
               const result = findKey(obj[key], val);
               if (result !== null) return result;
             }
           }
         }
       
         return null;
       };
      return findKey(this.newPassword.errors, req);
   }
}
